import { render, staticRenderFns } from "./cUserDetail.vue?vue&type=template&id=5d586ed6&scoped=true"
import script from "./cUserDetail.vue?vue&type=script&lang=js"
export * from "./cUserDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d586ed6",
  null
  
)

export default component.exports